import React from 'react';

import CompareButtonComponent from '@/components/CompareButton';
import { useTypedDispatch, useTypedSelector } from '@/store/store';
import {
  getComparisonCars,
  resetComparisonCars,
} from '@/store/reducers/cars-stock';
import { getComparisonCarsLink } from '@/modules/CarsStock/components/common.helpers';

import { CompareButtonWrapper } from '../../../common.styles';

function CompareButton() {
  const dispatch = useTypedDispatch();
  const comparisonCars = useTypedSelector(getComparisonCars);
  const comparisonCarsLink = getComparisonCarsLink(comparisonCars);

  if (comparisonCars.length === 0) {
    return null;
  }

  return (
    <CompareButtonWrapper>
      <CompareButtonComponent
        numberOfCompareCars={comparisonCars.length}
        link={comparisonCarsLink}
        onReset={() => dispatch(resetComparisonCars())}
      />
    </CompareButtonWrapper>
  );
}

export default CompareButton;
